import React from 'react';

import Modal from 'react-bootstrap/Modal';

const ConfirmationPopup = (props) => {
    
    // const [show, setShow] = React.useState(props.show)

    // React.useEffect(() => {
    //     setShow(props.show);
    // }, [props.show]);

    // return <Modal show={show} onHide={() => {if (props.onHide) props.onHide(); setShow(false)}} className="alert">
    return <Modal show={props.show} onHide={() => {if (props.onHide) props.onHide();}} className="alert">
        <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.text}</Modal.Body>
        <Modal.Footer>
            <button type="button" className="submit-btn" data-dismiss="modal" onClick={props.onConfirm}>{props.buttonText}</button>
        </Modal.Footer>
    </Modal>
}

export default ConfirmationPopup
